import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatTabGroup, MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { BaixaAnotacaoComponent } from "./baixa-anotacao/baixa-anotacao.component";
import { ConsultaHistoricoComponent } from "./consulta-historico/consulta-historico.component";
import { ConsultarEnderecoComponent } from "./consultar-endereco/consultar-endereco.component";
import { InclusaoAcaoComponent } from "./inclusao-acao/inclusao-acao.component";
import { RevogacaoOrdemComponent } from "./revogacao-ordem/revogacao-ordem.component";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "src/app/shared/components/dialog/dialog.component";
import { IamService } from "src/app/core/apis/iam/api/api";

@Component({
  selector: "app-cadastrar-ordem",
  templateUrl: "./cadastrar-ordem.component.html",
  styleUrls: ["./cadastrar-ordem.component.css"],
  standalone: true,
  imports: [
    MatToolbarModule,
    MatDividerModule,
    MatTabsModule,
    InclusaoAcaoComponent,
    ConsultarEnderecoComponent,
    BaixaAnotacaoComponent,
    ConsultaHistoricoComponent,
    RevogacaoOrdemComponent,
  ],
})
export class CadastrarOrdemComponent implements OnInit {

  tokenIam: string;

  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  ordem: any;

  constructor(
    private iamService: IamService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.tokenIam = sessionStorage.getItem("JWTToken");
    this.iamService.changeAccount(this.tokenIam).subscribe({
      next: response => {
        this.tokenIam  = response.body.accessToken;
        sessionStorage.setItem("JWTToken", this.tokenIam);
      },
      error: error => console.error(error)
    });
  }

  public selectTab(index: number, ordem: any): void {
    this.tabGroup.selectedIndex = index;
    if (ordem)
      this.ordem = ordem;
  }

  public handleOutrasSolicitacoes() {
    const data = {
      messages: ['Utilize essa opção apenas para envio de determinações que contenham assuntos diversos, tais como Serasa Score, Cadastro Positivo, Limpa Nome ou qualquer outro tema que não esteja especificado nas demais solicitações, inclusive determinações em que a Serasa é parte no Processo.'],
      confirmText: 'Prosseguir',
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '550px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirm)
        this.router.navigate(['cadastrar-ordem-outros']);
    });
  }
}
